import { Currency } from "@/constants/currency";
import { GroupErrors } from "@/constants/errors/group";
// import { IPOSConfig } from "@/types/db/pos-config";
import {
  Get_GroupInfoQuery,
  Get_GroupInfoQueryVariables,
  // Get_PosConfigsQuery,
  // Get_PosConfigsQueryVariables,
} from "@/types/gql/generated/graphql";
import { GroupInfo } from "@/types/gql/group";
// import { POSConfig } from "@/types/gql/PosConfigs";
import { apolloClient } from "@/utils/graphql-client";
// import { toLocalPOSConfig } from "@/utils/helpers/pos-config";
import {
  GET_GroupCurrencyExchange,
  GET_GroupEploToken,
  GET_GroupInfo,
} from "./queries/group.graphql";

/**
 * Returns sales configurations related to a user.
 *
 * @param groupId a list of ticket group ids
 */
export async function getGroupInfo(groupId: number): Promise<GroupInfo> {
  const res = await apolloClient.query<
    Get_GroupInfoQuery,
    Get_GroupInfoQueryVariables
  >({
    query: GET_GroupInfo,
    variables: { groupId: `${groupId}` },
    context: {},
  });

  const groupInfo = res.data.groupInfo;
  if (!groupInfo) {
    throw new Error(GroupErrors.NoGroupInfoFound);
  }

  return groupInfo;
}

/**
 * Returns currencies and exchange rates related to a user.
 *
 * @param groupId a list of group ids
 */
export async function getGroupCurrenciesExchange(
  groupId: number
): Promise<Currency[]> {
  const res = await apolloClient.query({
    query: GET_GroupCurrencyExchange,
    variables: { groupId: `${groupId}` },
  });

  const data = res.data;
  if (!data) {
    throw new Error(GroupErrors.NoGroupInfoFound);
  }

  return data.GroupCurrencyExchangeList;
}

/**
 * return Explo token for a given group
 * @param groupId
 */
export async function getGroupExploToken(groupId: number): Promise<string> {
  const res = await apolloClient.query({
    query: GET_GroupEploToken,
    variables: { groupId: `${groupId}` },
  });

  const data = res.data;
  if (!data) {
    throw new Error("No Explo token found for the group");
  }

  return data.GroupExploList[0].token;
}
